import './index.less'
import { IRoleDetails, RoleScopes } from '../../../configureRoles/constants'
import { RootState } from '../../../../rootReducer'
import {
  ACTION_FETCH_ROLE_DETAILS_BY_NAME,
  fetchRoleDetailsByName,
  resetRoleDetails
} from '../../../configureRoles/slice'
import { getShowLoader } from '../../../../reducers/requestReducer'

import ModalView from '../../../../components/ModalView/modalView'
import WidgetPermissionAccess from '../../../configureRoles/manageRoleDetails/tabsPermissions/widgetPermissionAccess'
import WidgetGeneral from '../../../configureRoles/manageRoleDetails/tabsPermissions/widgetGeneral'
import WidgetCustomPermissionAccess from '../../../configureRoles/manageRoleDetails/tabsPermissions/widgetCustomPermissionAccess'
import LoaderView from '../../../../components/Loader/loader'
import { connect } from 'react-redux'
import React, { useEffect } from 'react'
import { useIntl } from 'react-intl'

interface IProps {
  isOpened: boolean
  selectedRoleName?: string
  roleDetails: IRoleDetails
  showLoader: boolean
  resetRoleDetails: () => void
  onClose: () => void
  fetchRoleDetailsByName: (roleName: string) => void
}

const ModalSelectedRoleDefinition = (props: IProps) => {
  const intl = useIntl()
  const {
    selectedRoleName,
    roleDetails,
    showLoader,
    isOpened,
    onClose,
    fetchRoleDetailsByName,
    resetRoleDetails
  } = props

  useEffect(() => {
    if (selectedRoleName) {
      fetchRoleDetailsByName(selectedRoleName)
    }
  }, [selectedRoleName, fetchRoleDetailsByName])

  useEffect(() => {
    return () => {
      resetRoleDetails()
    }
  }, [resetRoleDetails])

  const isCustomRole = !selectedRoleName || roleDetails.scope === RoleScopes.CUSTOM

  return (
    <ModalView
      isOpened={isOpened}
      size="large"
      title={roleDetails?.displayName}
      onClose={onClose}
      btnCancel={intl.formatMessage({ id: 'btn.close' })}
      testId="modal-role-details-add-edit-user-page"
      className="modal-role-details-add-edit-user-page"
      content={
        showLoader ? (
          <LoaderView showLoader={showLoader} />
        ) : (
          <div>
            <WidgetGeneral isDetailsView={true} />
            {isCustomRole ? (
              <WidgetCustomPermissionAccess isDetailsView={true} />
            ) : (
              <WidgetPermissionAccess isDetailsView={true} />
            )}
          </div>
        )
      }
    />
  )
}

const mapStateToProps = (state: RootState) => ({
  roleDetails: state.configureRoles.roleDetails,
  showLoader: getShowLoader(ACTION_FETCH_ROLE_DETAILS_BY_NAME)
})

const mapDispatchToProps = {
  fetchRoleDetailsByName,
  resetRoleDetails
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalSelectedRoleDefinition)
